import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';

const useApprovalService = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const approveApproval = useCallback(
		async (issueKey: string, onSuccess: () => void, onFailure: () => void): Promise<void> => {
			try {
				await performPostRequest(
					`/rest/servicedesk/approvals/1/approval/request/${issueKey}/approve`,
				);
				fireOperationalAnalytics(
					createAnalyticsEvent({
						type: 'sendOperationalEvent',
						action: 'success',
						actionSubject: 'approveApproval',
					}),
					'approveApproval success',
				);
				onSuccess();
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (e: any) {
				fireErrorAnalytics({
					error: e,
					meta: {
						id: 'approveApproval',
						packageName: 'jiraIssueNavigatorIssueOperationsServices',
					},
				});
				onFailure();
			}
		},
		[createAnalyticsEvent],
	);

	const rejectApproval = useCallback(
		async (issueKey: string, onSuccess: () => void, onFailure: () => void): Promise<void> => {
			try {
				await performPostRequest(
					`/rest/servicedesk/approvals/1/approval/request/${issueKey}/reject`,
				);
				fireOperationalAnalytics(
					createAnalyticsEvent({
						type: 'sendOperationalEvent',
						action: 'success',
						actionSubject: 'approveApproval',
					}),
					'approveApproval success',
				);
				onSuccess();
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (e: any) {
				fireErrorAnalytics({
					error: e,
					meta: {
						id: 'approveApproval',
						packageName: 'jiraIssueNavigatorIssueOperationsServices',
					},
				});
				onFailure();
			}
		},
		[createAnalyticsEvent],
	);

	return {
		approveApproval,
		rejectApproval,
	};
};

export default useApprovalService;
